import { extendTheme, ThemeOverride } from '@chakra-ui/react';
import colors from './colors';
import fonts from './foundations/fonts';
import styles from './styles';

import { badgeTheme } from './components/Badge';
import Button from './components/Button/Button';
import { headingTheme } from './components/Heading';
import { inputTheme } from './components/Input';
import menuTheme from './components/Menu';
import { tableTheme } from './components/Table';
import Text from './components/Text';

const overrides: ThemeOverride = {
  initialColorMode: 'light',
  useSystemColorMode: false,
  colors,
  styles,
  fonts,
  components: {
    Button,
    Text,
    Badge: badgeTheme,
    Table: tableTheme,
    Heading: headingTheme,
    Input: inputTheme,
    Menu: menuTheme,
  },
};
export default extendTheme(overrides);
